import { createFileRoute } from "@tanstack/react-router"

import { AdStudioPage } from "~/components/UGCWorkspace/AdStudioPage"
import CustomHead from "~/components/SEOHead/CustomHead"
import AppLayout from "~/layouts/AppLayout"

function AdStudioRoute() {
  return (
    <AppLayout navCollapsible="icon" navIconFloat fixedViewport>
      <CustomHead
        title="Ad Studio | VidMax"
        description="Shape a product and creative brief into a clear UGC ad direction."
      />
      <AdStudioPage />
    </AppLayout>
  )
}

export const Route = createFileRoute("/create/ad-studio")({
  component: AdStudioRoute,
})
